/**
 * Product Recommendations Intent Support
 * Extends the product recommendations functionality to support both
 * related and complementary products from the Shopify Search & Discovery app
 */

(function() {
  'use strict';

  // Store intent data for each section
  window.productRecommendationIntents = window.productRecommendationIntents || {};

  // Function to intercept and modify AsyncView.load calls
  function interceptAsyncView() {
    // Wait for AsyncView to be available
    const checkAsyncView = setInterval(function() {
      // Check if the AsyncView module is available via the window object or require
      let AsyncView = null;

      // Try to access through various possible locations
      if (window.pixelunion && window.pixelunion.shopifyAsyncView) {
        AsyncView = window.pixelunion.shopifyAsyncView;
      } else if (window.AsyncView) {
        AsyncView = window.AsyncView;
      }

      if (AsyncView && AsyncView.load) {
        clearInterval(checkAsyncView);

        // Store the original load method
        const originalLoad = AsyncView.load.bind(AsyncView);

        // Override the load method
        AsyncView.load = function(url, options) {
          // Check if this is a product recommendations API call
          if (typeof url === 'string' && url.includes('/recommendations/products')) {
            // Extract section ID from URL
            const sectionIdMatch = url.match(/section_id=([^&]+)/);
            if (sectionIdMatch && sectionIdMatch[1]) {
              const sectionId = sectionIdMatch[1];
              const intentData = window.productRecommendationIntents[sectionId];

              if (intentData && intentData.intent) {
                // Add intent parameter if not already present
                if (!url.includes('intent=')) {
                  const separator = url.includes('?') ? '&' : '?';
                  url = url + separator + 'intent=' + intentData.intent;
                }
              }
            }
          }

          // Call the original load method with the modified URL
          return originalLoad(url, options);
        };
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(function() {
      clearInterval(checkAsyncView);
    }, 10000);
  }

  // Function to collect intent data from sections
  function collectIntentData() {
    // Use try-catch for safety
    try {
      const recommendationSections = document.querySelectorAll('[data-section-type="static-product-recommendations"]');

      if (!recommendationSections || recommendationSections.length === 0) {
        return; // No sections found, exit gracefully
      }

      recommendationSections.forEach(function(sectionScript) {
        // Add null check
        if (!sectionScript || !sectionScript.textContent) {
          return; // Skip if element or content is null
        }

        try {
          const sectionData = JSON.parse(sectionScript.textContent);

          // Safe property access
          const intent = (sectionData && sectionData.settings && sectionData.settings.intent)
                        ? sectionData.settings.intent
                        : 'related';
          const sectionId = sectionData && sectionData.sectionId;

          if (sectionId) {
            window.productRecommendationIntents[sectionId] = {
              intent: intent
            };
          }
        } catch (e) {
          // Silent fail for individual sections
          console.warn('Could not parse recommendation section data:', e);
        }
      });
    } catch (e) {
      console.warn('Error collecting intent data:', e);
    }
  }

  // Initialize
  function init() {
    try {
      collectIntentData();
      interceptAsyncView();

      // Also intercept fetch as a fallback
      if (window.fetch) {
        const originalFetch = window.fetch;
        window.fetch = function() {
          try {
            let url = arguments[0];

            // Check if this is a product recommendations API call
            if (typeof url === 'string' && url.includes('/recommendations/products')) {
              const sectionIdMatch = url.match(/section_id=([^&]+)/);
              if (sectionIdMatch && sectionIdMatch[1]) {
                const sectionId = sectionIdMatch[1];
                const intentData = window.productRecommendationIntents[sectionId];

                if (intentData && intentData.intent && !url.includes('intent=')) {
                  const separator = url.includes('?') ? '&' : '?';
                  arguments[0] = url + separator + 'intent=' + intentData.intent;
                }
              }
            }
          } catch (e) {
            console.warn('Error in fetch interceptor:', e);
          }

          return originalFetch.apply(this, arguments);
        };
      }
    } catch (e) {
      console.error('Error initializing product recommendations intent:', e);
    }
  }

  // Run initialization with delay to ensure DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Add small delay to ensure all elements are rendered
      setTimeout(init, 100);
    });
  } else {
    // DOM already loaded, still add small delay
    setTimeout(init, 100);
  }

})();
